module.exports = __webpack_public_path__ + "img/image 31.1dc07eb0.svg";